import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

// Create an HTTP link to your GraphQL endpoint
const httpLink = new HttpLink({
    uri: 'https://' + process.env.GATSBY_MYSHOPIFY_URL + '/api/2025-07/graphql.json', // Replace with your Shopify GraphQL endpoint
    headers: {
        'X-Shopify-Storefront-Access-Token': process.env.GATSBY_STOREFRONT_ACCESS_TOKEN, // Replace with your access token
        'Content-Type': 'application/json',
    },
});

// Create an Apollo Client instance
const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    ssrMode: typeof window === "undefined",
});

export default client;